module.exports = __webpack_public_path__ + "img/26.be88971f.png";